import { DashboardLayout } from '@/platform/layouts';
import { Container } from '@/platform/ui';
import BaseEmployeeInfo from '../components/BaseEmployeeInfo';
import EmployeeNavigation from '../components/EmployeeNavigation';

const EmployeeShowLayout = ({ children }) => (
    <DashboardLayout>
        <Container fluid>
            <BaseEmployeeInfo />

            <div className='flex flex-col gap-8 lg:flex-row'>
                <EmployeeNavigation />

                <div className='min-w-0 flex-1'>{children}</div>
            </div>
        </Container>
    </DashboardLayout>
);

export default EmployeeShowLayout;
